import { fetcher } from "@/shared/core-configs";
import { LocalProductInput, LocalProduct } from "../types/LocalProduct";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_EXTERNAL_PRODUCTS_FETCH_KEY } from "./useGetLocalProduct";
import { getErrorMessage } from "@/utils/getErrorMessage";

export const createLocalProduct = async (
  newLocalProduct: LocalProductInput,
): Promise<LocalProduct> => {
  try {
    console.log("Datos enviados al servidor:", newLocalProduct);

    const response = await fetcher.post(
      `${API.GESLUB}/external-product`,
      newLocalProduct,
    );

    console.log("Respuesta del servidor:", response);

    return response.data;
  } catch (error) {
    console.error(
      "Error en la solicitud de creación de producto local:",
      error,
    );
    throw new Error(
      getErrorMessage(error, "Ocurrió un error al crear el producto local."),
    );
  }
};

export const useCreateLocalProduct = () => {
  const queryClient = useQueryClient();

  return useMutation<LocalProduct, Error, LocalProductInput>({
    mutationFn: createLocalProduct,
    onSuccess: () => {
      console.log("Producto creado exitosamente.");
      queryClient.invalidateQueries({
        queryKey: [GET_EXTERNAL_PRODUCTS_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error al crear el producto externo:", error);
    },
  });
};
